<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ itemsCoreData.activeItems.length }})">
    <div class="vs-section-content vs-threeCards-grid mt-3" [ngClass]="class">
      <div class="mat-card has-outline-menu p-4 mat-elevation-z4" *ngFor="let benefit of itemsCoreData.activeItems">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar item" (click)="sendItemEdit(benefit)">
            <mat-icon>edit</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" (click)="sendItemAvailability(benefit.id)"
                  [matTooltip]="benefit['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'" *ngIf="itemsCoreData.activeItems.length > 1">
            <mat-icon>{{benefit['status'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar item"
                  (click)="sendItemDelete(benefit.id)" *ngIf="itemsCoreData.activeItems.length > 1">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content-as-column">
          <img [src]="benefit['img'] | safeDom" [alt]="'img-card'+ benefit['id']"
               onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
          <h4 class="mb-0 mt-2"><strong>{{benefit['title']}}</strong></h4>
          <span>{{benefit['subTitle']}}</span>
          <span>{{benefit['subTitle2']}}</span>
        </div>
      </div>
    </div>
    <div class="w-100 text-center" *ngIf="!itemsCoreData.activeItems.length">
      <h2 class="mb-4">No existen datos habilitados</h2>
    </div>
  </mat-tab>
  <mat-tab label="Deshabilitados ({{ itemsCoreData.noActiveItems.length }})">
    <div class="vs-section-content vs-threeCards-grid mt-3" [ngClass]="class">
      <div class="mat-card has-outline-menu p-4 mat-elevation-z4 disabled-vs-content"
           *ngFor="let benefit of itemsCoreData.noActiveItems">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  (click)="sendItemAvailability(benefit.id)"
                  [matTooltip]="benefit['status'] === 'Activo' ? 'Ocultar item' : 'Mostrar item'">
            <mat-icon>{{benefit['status'] === 'Activo' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
          </button>
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                  matTooltip="Eliminar item"
                  (click)="sendItemDelete(benefit.id)">
            <mat-icon>delete_forever</mat-icon>
          </button>
        </div>
        <div class="content-as-column">
          <img [src]="benefit['img']" [alt]="'img-card'+ benefit['id']"
               onerror="this.onerror= null; this.src = 'assets/images/img-placeholder.png'">
          <h4 class="mb-0 mt-2"><strong>{{benefit['title']}}</strong></h4>
          <p>{{benefit['subTitle']}}</p>
        </div>
      </div>
    </div>
    <div class="w-100 text-center" *ngIf="!itemsCoreData.noActiveItems.length">
      <h2 class="mb-4">No existen datos deshabilitados</h2>
    </div>
  </mat-tab>
</mat-tab-group>
